import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { Stack, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import {
  AmendmentCell,
  BiomassBurningCell,
  CashCropCell,
  CoverCropCell,
  FertilizerCell,
  IrrigationCell,
  LimingCell,
  LivestockCell,
  NaturalDisturbanceCell,
  TillageCell,
  WaterPumpIrrigationCell,
} from './TraitCells'

interface TaskEditorTableCellProps extends GridRenderCellParams {
  row: {
    traitId: string
    [key: string]: any
  }
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const TaskEditorTableCell = ({
  row: { traitId },
  value,
  field: year,
  task,
  selectedField,
  onSaveSuccess,
}: TaskEditorTableCellProps) => {
  switch (traitId) {
    case 'naturalDisturbance':
      return (
        <NaturalDisturbanceCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'waterPumpIrrigation':
      return (
        <WaterPumpIrrigationCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'cashCrop':
      return (
        <CashCropCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'tillage':
      return (
        <TillageCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'coverCrop':
      return (
        <CoverCropCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'biomassBurning':
      return (
        <BiomassBurningCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'livestock':
      return (
        <LivestockCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'fertilizer':
      return (
        <FertilizerCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'amendment':
      return (
        <AmendmentCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'irrigation':
      return (
        <IrrigationCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    case 'liming':
      return (
        <LimingCell
          value={value}
          task={task}
          selectedField={selectedField}
          year={+year}
          onSaveSuccess={onSaveSuccess}
        />
      )
    default:
      return (
        <Stack>
          <Typography>{JSON.stringify(value)}</Typography>
        </Stack>
      )
  }
}
